import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/theme.css';

import App from './App';
import { consumeHandoffAtBoot } from './lib/handoff';

// Helm XR web windows: a #nx_handoff=<ticket> is redeemed before routing and the auth check
// (lib/handoff.ts).
void consumeHandoffAtBoot().finally(() => {
  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>,
  );
});
